import type {
  AmountMode,
  MatchingAction,
  MatchingCsvAction,
  ManualPayDecision,
} from "../types/matching";

export interface RowDecisionDefaults {
  manualPay: ManualPayDecision;
  amountMode: AmountMode;
  action: MatchingAction;
}

/**
 * Local-only mapping of MatchAction → collapsed `action` / `manualPay` /
 * `amountMode` for row-edit, bulk actions, and local fixtures.
 *
 * **Not on the agent wire.** `toContractRow` sends `matchAction` only; the
 * API MyPay adapters map verbs to Christmas `manualFlag` / `manualAmount`
 * (Product-PRDs #406).
 *
 * APPLY / REAPPLY → override on, amount kept (REAPPLY reinstates retained).
 * DELETE_KEEP_AMOUNT → override off, stored amount retained (R-APP-13a).
 * DELETE → override off, amount removed (R-APP-13c).
 */
export function deriveRowDecisions(
  matchAction: MatchingCsvAction,
  _targetAmount: number | null
): RowDecisionDefaults {
  switch (matchAction) {
    case "DELETE":
      return { manualPay: false, amountMode: "REMOVE", action: "DELETE" };
    case "DELETE_KEEP_AMOUNT":
      return { manualPay: false, amountMode: "KEEP", action: "DELETE" };
    case "REAPPLY":
    case "APPLY":
      return { manualPay: true, amountMode: "KEEP", action: "APPLY" };
  }
}
